export default {
    "lang": "泰语",
    "application": {
        "name": "ระบบเผยแพร่ข้อมูล"
    },
    "ajaxTip": {
        "success": "สำเร็จ",
        "error": "ล้มเหลว",
        "noAccess": "ไม่มีสิทธิ์เข้าถึงทรัพยากรนี้",
        "notFound": "ทรัพยากรที่เข้าถึงไม่มีอยู่",
        "serverBusy": "เซิร์ฟเวอร์มีภาระงานหนัก",
        "timeOut": "หมดเวลา"
    },
    "menu": {
        "home": "หน้าแรก",
        "template": "จัดการเทมเพลต",
        "program": "จัดการโปรแกรม",
        "playplan": "แผนการเล่น",
        "device": "จัดการอุปกรณ์",
        "source-material": "จัดการวัสดุ",
        "material": "วัสดุ",
        "checkManage": "จัดการการตรวจสอบ",
        "setting": "การตั้งค่า",
        "usercenter": "ศูนย์ผู้ใช้",
        "adminManage": "จัดการอุปกรณ์",
        "schedule": "รายการสิ่งที่ต้องทำ",
        "capitalassets": "จัดการทรัพย์สิน",
        "modifyPassword": "เปลี่ยนรหัสผ่าน",
        "logout": "ออกจากระบบ",
        "add": "เพิ่ม",
        "edit": "แก้ไข",
        "delete": "ลบ",
        "view": "ดู",
        "menu_1": "หน้าหลัก",
        "menu_2": "การจัดการอุปกรณ์",
        "menu_3": "แก้ไข (การตั้งค่าขั้นสูง - แก้ไขเบasic - เปลี่ยนเครือข่าย)",
        "menu_4": "คำสั่ง tức thì",
        "menu_5": "แก้ไข (ย้ายแผนก)",
        "menu_6": "กลยุทธ์",
        "menu_7": "การตั้งค่าเสียง",
        "menu_8": "การตั้งค่าความสว่าง",
        "menu_9": "การตั้งค่าดาวน์โหลด",
        "menu_10": "การตั้งค่าเข้านอน",
        "menu_11": "คุณสมบัติอุปกรณ์",
        "menu_12": "แก้ไข/เพิ่ม",
        "menu_13": "การจัดการโปรแกรม",
        "menu_14": "ประวัติการเผยแพร่",
        "menu_15": "ลบ (ชุด/รายการเดี่ยว)",
        "menu_16": "โปรแกรมที่กำลังเผยแพร่",
        "menu_17": "หมวดหมู่",
        "menu_19": "รายการโปรแกรม",
        "menu_20": "แก้ไขเนื้อหา",
        "menu_21": "คัดลอกโปรแกรม",
        "menu_23": "เผยแพร่โปรแกรม",
        "menu_24": "การจัดการวัสดุ",
        "menu_25": "อัปโหลด",
        "menu_28": "เผยแพร่เร็ว",
        "menu_29": "การจัดการเทมเพลต",
        "menu_30": "เทมเพลตสาธารณะ",
        "menu_31": "ใช้งานทันที",
        "menu_32": "เทมเพลตของฉัน",
        "menu_33": "เผยแพร่ไปยังเทมเพลตสาธารณะ",
        "menu_35": "ประวัติการแชร์",
        "menu_36": "การจัดการตรวจสอบ",
        "menu_37": "ตรวจสอบโปรแกรม",
        "menu_38": "ตรวจสอบ (อนุมัติ/ปฏิเสธ)",
        "menu_39": "ตรวจสอบวัสดุ",
        "menu_41": "ประวัติการตรวจสอบ (ผู้ปฏิบัติงาน)",
        "menu_42": "ประวัติการตรวจสอบ (ผู้ตรวจสอบ)",
        "menu_43": "ดูจำนวนการอนุมัติ",
        "menu_44": "การจัดการองค์กร",
        "menu_45": "การจัดการบันทึก",
        "menu_46": "บันทึกการเล่น",
        "menu_47": "บันทึกการเผยแพร่",
        "menu_48": "บันทึกข้อผิดพลาด",
        "menu_49": "บันทึกการปฏิบัติงาน",
        "menu_50": "บันทึกไฟล์",
        "menu_51": "บันทึกการเข้าสู่ระบบ",
        "menu_52": "อนุมัติเนื้อหา",
        "menu_53": "พื้นที่จัดเก็บ",
        "menu_54": "โครงสร้างองค์กร",
        "menu_55": "สิทธิ์บทบาท",
        "menu_56": "การให้สิทธิ์",
        "menu_57": "ดู (สิทธิ์การให้สิทธิ์)",
        "menu_58": "สมาชิกองค์กร",
        "menu_60": "รีเซ็ตรหัสผ่านผู้ใช้ระดับล่าง",
        "menu_61": "การจัดการทรัพย์สิน",
        "menu_62": "ยอดคงเหลือของฉัน",
        "menu_63": "ดู (รายละเอียดกองทุน)",
        "menu_64": "การใช้งานข้อมูลของฉัน",
        "menu_65": "ดู (รายละเอียดการใช้งานข้อมูล)",
        "menu_66": "ซื้อการใช้งานข้อมูล",
        "menu_67": "ความจุของฉัน",
        "menu_68": "อุปกรณ์ของฉัน",
        "menu_69": "รายละเอียดคำสั่งซื้อ",
        "menu_70": "ดู (เติมเงิน)",
        "menu_71": "ดู (เทมเพลตที่ซื้อ)",
        "menu_72": "ดู (การใช้งานข้อมูลที่ซื้อ)",
        "menu_73": "สิทธิ์อื่นๆ",
        "menu_74": "ดู (สถิติวัสดุและโปรแกรม)",
        "menu_75": "ดู (ทรัพย์สิน)",
        "menu_76": "ดู (การใช้งานข้อมูลคลาวด์/สถิติ)",
        "menu_77": "ดู (สถิติอุปกรณ์ออนไลน์)"
    },
    "login": {
        "terminalServiceSystem": "ระบบบริการเทอร์มินัลอัจฉริยะ",
        "accountLogin": "เข้าสู่ระบบด้วยบัญชี",
        "register": "ลงทะเบียน",
        "accountLoginTip": "เข้าสู่ระบบด้วยบัญชีที่มีอยู่แล้ว",
        "scanQRCode": "โปรดสแกนรหัส QR",
        "readAndAgree": "ฉันได้อ่านและยอมรับ",
        "readAndAgreeLink": "ข้อกำหนดบริการผู้ใช้",
        "readAndAgreeAgreement": "โปรดอ่านและยอมรับข้อกำหนดบริการผู้ใช้",
        "forgetpassword": "ลืมรหัสผ่าน?",
        "resetpassword": "รีเซ็ตรหัสผ่าน",
        "phoneEmptyTip": "โปรดป้อนหมายเลขโทรศัพท์มือถือ",
        "nextStep": "ขั้นตอนต่อไป",
        "title": "ยินดีต้อนรับเข้าสู่ระบบ",
        "submit": "เข้าสู่ระบบ",
        "userName": "บัญชี",
        "password": "รหัสผ่าน",
        "userNameEmptyTip": "โปรดป้อนบัญชี",
        "passwordEmptyTip": "โปรดป้อนรหัสผ่าน",
        "passwordFormatTip": "โปรดป้อนรูปแบบรหัสผ่านที่ถูกต้อง",
        "passwordIsOk": "โปรดป้อนรหัสผ่านยืนยัน",
        "passwordSign": "โปรดป้อนรหัสผ่าน",
        "codeTip": "โปรดป้อนรหัสยืนยัน",
        "phone": "หมายเลขโทรศัพท์มือถือห้ามว่างเปล่า",
        "code": "รหัสยืนยันห้ามว่างเปล่า",
        "nickname": "ชื่อบริษัทห้ามว่างเปล่า",
        "pass": "รหัสผ่านห้ามว่างเปล่า",
        "pwdMessage": "รหัสผ่านต้องมีความยาว 8-20 ตัวอักษร ไม่สามารถมีช่องว่างได้ และต้องประกอบด้วย 3 ประเภทต่อไปนี้: ตัวอักษรพิมพ์ใหญ่、ตัวอักษรพิมพ์เล็ก、ตัวเลข、อักขระพิเศษ",
        "pwdMessage01": "โปรดป้อนรหัสผ่านที่ประกอบด้วยตัวอักษรและตัวเลขอย่างน้อย 8 ตัว",
        "pwdMessage02": "รหัสผ่านต้องมีความยาว 8-20 ตัวอักษร",
        "pwdMessage03": "รหัสผ่านไม่สามารถมีช่องว่างได้",
        "pwdMessage04": "รหัสผ่านต้องประกอบด้วย 3 ประเภทต่อไปนี้: ตัวอักษรพิมพ์ใหญ่、ตัวอักษรพิมพ์เล็ก、ตัวเลข、อักขระพิเศษ",
        "newpassempty": "รหัสผ่านใหม่ห้ามว่างเปล่า",
        "newpass": "รหัสผ่านสองครั้งไม่ตรงกัน",
        "getcode": "รับรหัสยืนยัน",
        "format": "รูปแบบหมายเลขโทรศัพท์มือถือไม่ถูกต้อง",
        "chongfa": "ส่งซ้ำหลังจาก วินาที",
        "isSend": "ได้ส่งแล้ว",
        "noregister": "ไม่มีบัญชี? ลงทะเบียนทันที",
        "Mobile": "หมายเลขโทรศัพท์มือถือ",
        "verificationcode": "รหัสยืนยัน",
        "petname": "ชื่อเล่น",
        "Quickregistration": "ลงทะเบียนเร็ว",
        "xiugaimima": "เปลี่ยนรหัสผ่าน",
        "jiumima": "รหัสผ่านเก่า",
        "xinmima": "รหัสผ่านใหม่",
        "zaicishuruxinmima": "ป้อนรหัสผ่านใหม่อีกครั้ง",
        "xiugaichenggong": "เปลี่ยนสำเร็จ",
        "xiugaishoujihao": "เปลี่ยนหมายเลขโทรศัพท์มือถือ",
        "dengluzhanghao": "บัญชีเข้าสู่ระบบ",
        "gongsiid": "ID บริษัท",
        "yonghunicheng": "ชื่อเล่นผู้ใช้",
        "chuangjianshijian": "เวลาสร้าง",
        "gongsimingcheng": "ชื่อบริษัท",
        "denglumima": "รหัสผ่านเข้าสู่ระบบ",
        "jianyi": "แนะนำให้ใช้รหัสผ่านที่ประกอบด้วยตัวอักษรและตัวเลข",
        "shezhimima": "ตั้งรหัสผ่าน",
        "shezhishoujihao": "เปลี่ยน/ตั้งหมายเลขโทรศัพท์มือถือ",
        "yibangding": "ได้ผูกแล้ว",
        "weibangding": "ยังไม่ผูก",
        "zhanghuanquan": "ความปลอดภัยของบัญชี",
        "yonghuxinxi": "ข้อมูลผู้ใช้",
        "zhuceSucMsg": "ยินดีด้วย ลงทะเบียนสำเร็จ!",
        "verificationcodeSucMsg": "ส่งรหัสยืนยันสำเร็จ!",
        "requiredIsEmpty": "ช่องที่จำเป็นห้ามว่างเปล่า!",
        "emailObj": {
            "title": "อีเมล",
            "tit": "เข้าสู่ระบบด้วยอีเมล",
            "tip": "โปรดป้อนที่อยู่อีเมล",
            "formatTip": "โปรดป้อนรูปแบบอีเมลที่ถูกต้อง"
        },
        "phoneObj": {
            "title": "หมายเลขโทรศัพท์มือถือ",
            "tit": "เข้าสู่ระบบด้วยโทรศัพท์มือถือ",
            "tip": "โปรดป้อนหมายเลขโทรศัพท์มือถือ",
            "formatTip": "โปรดป้อนรูปแบบหมายเลขโทรศัพท์มือถือที่ถูกต้อง"
        },
        "emailOrPhoneObj": {
            "title": "อีเมลหรือหมายเลขโทรศัพท์มือถือ",
            "tit": "เข้าสู่ระบบด้วยอีเมลหรือหมายเลขโทรศัพท์มือถือ",
            "tip": "โปรดป้อนอีเมลหรือหมายเลขโทรศัพท์มือถือ",
            "formatTip": "โปรดป้อนรูปแบบอีเมลหรือหมายเลขโทรศัพท์มือถือที่ถูกต้อง"
        },
        "wechatObj": {
            "title": "WeChat",
            "tit": "เข้าสู่ระบบด้วย WeChat"
        },
        "googleObj": {
            "title": "Google",
            "tit": "เข้าสู่ระบบด้วย Google"
        },
        "confirm": "ยืนยัน",
        "confirmSubmit": "ยืนยันและส่ง",
        "cancel": "ยกเลิก",
        "close": "ปิด",
        "bindSucMsg": "ผูกสำเร็จ",
        "toContinueBindAccount": "ดำเนินการต่อเพื่อ완료การผูกบัญชีบุคคลที่สาม",
        "bindTip01": "ไม่มีบัญชี? ลงทะเบียน",
        "bindTip02": "มีบัญชีแล้ว",
        "bindTip03": "บัญชีบุคคลที่สามปัจจุบันยังไม่ได้ผูกกับบัญชีแพลตฟอร์ม โปรดผูกกับบัญชีที่มีอยู่หรือลงทะเบียนและผูกบัญชีใหม่ สามารถเข้าสู่ระบบได้เร็วในครั้งต่อไป",
        "bindTip04": "ผูกกับบัญชีที่มีอยู่",
        "bindTip05": "ลงทะเบียนและผูกบัญชีใหม่",
        "bindTip06": "คุณได้รับอนุญาตจากบุคคลที่สามแล้ว กรุณาเสริมข้อมูลเข้าสู่ระบบด้านล่างเพื่อ완료การผูก",
        "bindSubmit": "ส่งและผูก",
        "enterAccountTip": "โปรดป้อนชื่อบัญชี",
        "RegisterAndBind": "ลงทะเบียนและผูก",
        "loginErr": "ชื่อผู้ใช้หรือรหัสผ่านผิด!",
        "usercenter": "ศูนย์ผู้ใช้",
        "pleaseInputName": "โปรดป้อนชื่อ",
        "operationSuccess": "ดำเนินการสำเร็จ!",
        "edit": "แก้ไข",
        "xiugai": "เปลี่ยน",
        "userData": "ข้อมูลส่วนตัว",
        "changePassword": "เปลี่ยนรหัสผ่าน",
        "account": "บัญชี",
        "userName01": "ชื่อผู้ใช้",
        "phoneNumber": "หมายเลขโทรศัพท์มือถือ",
        "role": "บทบาท",
        "createTime": "เวลาสร้าง",
        "genghuang": "เปลี่ยน",
        "bangding": "ผูก",
        "unbind": "ยกเลิกการผูก",
        "plesaseSelectBindingType": "โปรดเลือกประเภทการผูก",
        "pleaseConfirmCont": "โปรดยืนยันว่าฉันได้อ่านเนื้อหานี้",
        "confirmReadCont": "ฉันได้อ่านเนื้อหานี้",
        "frequentTip": "ดำเนินการบ่อยเกินไป โปรดลองอีกครั้งในภายหลัง!",
        "zhuxiaoBtn": "ยกเลิกบัญชี",
        "zhuxiaoTitle": "ยกเลิกบัญชี",
        "querenZhuxiao": "ยืนยันการยกเลิก",
        "jiXu": "ดำเนินการต่อ",
        "sendCodeBtn": "ส่งรหัสยืนยัน",
        "passwordIsNotOldPassword": "รหัสผ่านยืนยันไม่ตรงกับรหัสผ่านใหม่",
        "passwordIsOldPassword": "รหัสผ่านที่เปลี่ยนตรงกับรหัสผ่านเดิม",
        "passFormatError": "โปรดป้อนรูปแบบรหัสผ่านที่ถูกต้อง",
        "oldPassWord": "รหัสผ่านเดิม",
        "newPassWord": "รหัสผ่านใหม่",
        "inputPlaceholder": "โปรดป้อน",
        "confirmPassword": "ยืนยันรหัสผ่าน",
        "zhuxiaoTip": "1、การยกเลิกบัญชีเป็นการดำเนินการที่ไม่สามารถกู้คืนได้ เมื่อบัญชีถูกยกเลิก คุณจะไม่สามารถเข้าสู่ระบบและใช้งานบัญชีนี้หรือบัญชีบุคคลที่สามที่ลงทะเบียนและเข้าสู่ระบบผ่านบัญชีนี้ได้อีก โปรดสำรองข้อมูลและข้อมูลที่เกี่ยวข้องกับบัญชีด้วยตนเอง.\n2、ก่อนลงทะเบียนบัญชีนี้ โปรดยืนยันว่าคุณได้ล้างทรัพย์สินทั้งหมดและไม่มีข้อพิพาทใดๆ; เมื่อบัญชีนี้ถูกยกเลิก จะถือว่าคุณยอมละทิ้งกรรมสิทธิ์ในทรัพย์สินและสิทธิ์ทั้งหมดในบัญชีนี้ และไม่สามารถกู้คืนหรือค้นหาได้.\n3、หากจำนวนการยกเลิกบัญชีที่ลงทะเบียนด้วยหมายเลขโทรศัพท์มือถือเดียวกันถึง 3 ครั้ง จะไม่สามารถลงทะเบียนบัญชีใหม่ได้อีก และยังไม่สามารถผูกกับบัญชีอื่นใดได้ด้วย."
    },
    "home": {
        "title": "หน้าแรก",
        "quickOperation": "การดำเนินการรวดเร็ว",
        "addDevice": "เพิ่มอุปกรณ์",
        "publishProgram": "เผยแพร่โปรแกรม",
        "publishMaterial": "เผยแพร่วัสดุ",
        "makeProgram": "สร้างโปรแกรม",
        "uploadMaterial": "อัปโหลดวัสดุ",
        "todayData": "ข้อมูลวันนี้ (อัปเดตทุกชั่วโมง)",
        "playNumChart": "สถิติจำนวนการเล่น",
        "deviceOnlineStatus": "สถานะออนไลน์ของอุปกรณ์",
        "onLineDevice": "อุปกรณ์ออนไลน์",
        "unLineDevice": "อุปกรณ์ออฟไลน์",
        "programPlayTime": "สถิติระยะเวลาการเล่นโปรแกรม",
        "downloadSoft": "ดาวน์โหลดซอฟต์แวร์",
        "adminApp": "แอปพลิเคชันมือถือสำหรับผู้ดูแล",
        "playerApp": "เทอร์มินัลเล่นเผยแพร่ข้อมูล",
        "downloadAdminApp": "คลิกเพื่อดาวน์โหลดแอปพลิเคชันสำหรับผู้ใช้",
        "downloadPlayerApp": "คลิกเพื่อดาวน์โหลดแอปพลิเคชันเล่น",
        "aboutUs": "เกี่ยวกับเรา",
        "userManual": "คู่มือผู้ใช้",
        "message": "ฉันต้องการส่งข้อความ"
    },
    "device": {
        "inputPlaceholder": "โปรดป้อน",
        "selectPlaceholder": "โปรดเลือก",
        "osTypeStr": "ระบบปฏิบัติการเทอร์มินัล",
        "onLineStatus": "สถานะออนไลน์",
        "dpi": "ความละเอียด",
        "companyDeptIdName": "องค์กรที่สังกัด",
        "deviceGroupIdName": "กลุ่มที่สังกัด",
        "editOrMove": "แก้ไข/ย้าย",
        "loanOriginationFee": "ค่าธรรมเนียมการกู้ยืม",
        "strategyInfoLook": "ดูข้อมูลกลยุทธ์",
        "programLook": "ดูโปรแกรม",
        "addEquipments": "เพิ่มอุปกรณ์",
        "luminanceSet": "ควบคุมความสว่าง",
        "terminal": "การตั้งค่าเทอร์มินัล",
        "transferCompany": "ย้ายแผนก",
        "releasedProgram": "เผยแพร่โปรแกรม",
        "screenshot": "ถ่ายหน้าจอ",
        "changeGroup": "เปลี่ยนกลุ่ม",
        "defaultGroup": "กลุ่มเริ่มต้น",
        "operation": "การดำเนินการ",
        "edit": "แก้ไข",
        "saveEdit": "บันทึกการแก้ไข",
        "add": "เพิ่ม",
        "save": "บันทึก",
        "setting": "การตั้งค่า",
        "program": "โปรแกรม",
        "unbind": "ยกเลิกการผูก",
        "sleep": "เข้าสู่โหมดหลับ",
        "wakeup": "ปลุก",
        "restart": "รีสตาร์ท",
        "shutdown": "ปิดเครื่อง",
        "reportLog": "รายงานบันทึก",
        "clearPlayData": "ล้างข้อมูลเทอร์มินัลเล่น",
        "offlineWarn": "อุปกรณ์นี้ออฟไลน์ โปรดลองอีกครั้งหลังจากอุปกรณ์ออนไลน์!",
        "confirmUnbind": "ยืนยันการยกเลิกการผูก",
        "confirmReset": "ยืนยันการล้าง",
        "confirmDelete": "ยืนยันการลบ",
        "delete": "ลบ",
        "cancelDelete": "ยกเลิกการลบ",
        "confirmResetSuccess": "ล้างสำเร็จ",
        "confirm": "ยืนยัน",
        "cancel": "ยกเลิก",
        "operationSuccess": "ดำเนินการสำเร็จ",
        "unbindSuccess": "ยกเลิกการผูกสำเร็จ",
        "pleaseSelectDevice": "โปรดเลือกอุปกรณ์",
        "pleaseSelectOnlineDevice": "โปรดเลือกอุปกรณ์ออนไลน์",
        "confirmMixOperation": "อุปกรณ์ที่เลือกมีอุปกรณ์ออฟไลน์ การตั้งค่านี้จะไม่ใช้งานกับอุปกรณ์ออฟไลน์ ยืนยันการดำเนินการต่อ?",
        "pleaseSelectDate": "โปรดเลือกวันที่",
        "reportSuccess": "รายงานสำเร็จ",
        "deviceSetting": "การตั้งค่าอุปกรณ์",
        "default": "เริ่มต้น",
        "all": "ทั้งหมด",
        "deviceList": "รายการอุปกรณ์",
        "addDevice": "เพิ่มอุปกรณ์",
        "department": "โครงสร้างแผนก",
        "deviceType": "ความละเอียด",
        "osType": "ระบบปฏิบัติการเทอร์มินัล",
        "onlineState": "สถานะออนไลน์",
        "online": "ออนไลน์",
        "offline": "ออฟไลน์",
        "notActive": "ยังไม่เปิดใช้งาน",
        "search": "โปรดป้อนคำค้นหา",
        "batchOperation": "การดำเนินการชุด",
        "allDevices": "อุปกรณ์ทั้งหมด",
        "deviceAttribute": "คุณสมบัติอุปกรณ์",
        "selectReportDate": "เลือกวันที่รายงาน",
        "inputName": "โปรดป้อนชื่อ",
        "inputWidth": "โปรดป้อนความกว้าง",
        "inputHeight": "โปรดป้อนความสูง",
        "inputResolutionRatio": "โปรดป้อนจำนวนเต็มที่มากกว่า 0!",
        "inputSort": "โปรดป้อนการเรียงลำดับ",
        "serialNum": "หมายเลขลำดับ",
        "name": "ชื่อ",
        "width": "ความกว้าง",
        "height": "ความสูง",
        "resolutionRatio": "ความละเอียด",
        "inputResolutionRatioName": "โปรดป้อนชื่อความละเอียด",
        "sort": "การเรียงลำดับ",
        "personal": "ส่วนตัว",
        "system": "ระบบ",
        "type": "ประเภท",
        "systemDefaultSettingUneditable": "การตั้งค่าเริ่มต้นของระบบไม่สามารถแก้ไขได้!",
        "systemDefaultSettingUnDeletable": "การตั้งค่าเริ่มต้นของระบบไม่สามารถลบได้!",
        "newz": "เพิ่มใหม่",
        "total": "ทั้งหมด",
        "totalNum": "รายการ",
        "strategyName": "ชื่อกลยุทธ์",
        "associatedTerminalNum": "จำนวนเทอร์มินัลที่เชื่อมโยง",
        "createTime": "เวลาสร้าง",
        "pleaseSelectStrategy": "โปรดเลือกกลยุทธ์!",
        "onlySelectOneData": "สามารถเลือกข้อมูลเพียงรายการเดียวเท่านั้น!",
        "downloadStrategy": "ดาวน์โหลดกลยุทธ์",
        "inputStrategyName": "โปรดป้อนชื่อกลยุทธ์",
        "luminanceControl": "ควบคุมความสว่าง",
        "volumeStrategy": "กลยุทธ์ระดับเสียง",
        "saveSuccess": "บันทึกสำเร็จ",
        "screenAngle": "การหมุนหน้าจอ (°)",
        "startTime": "เวลาเริ่มต้น",
        "endTime": "เวลาสิ้นสุด",
        "repeat": "ซ้ำ",
        "monday": "วันจันทร์",
        "tuesday": "วันอังคาร",
        "wednesday": "วันพุธ",
        "thursday": "วันพฤหัสบดี",
        "friday": "วันศุกร์",
        "saturday": "วันเสาร์",
        "sunday": "วันอาทิตย์",
        "everyday": "ทุกวัน",
        "downloadSpeed": "ความเร็วดาวน์โหลด",
        "inputDownloadSpeed": "โปรดป้อนความเร็วดาวน์โหลด",
        "operator": "การดำเนินการ",
        "pleaseSelectDeleteData": "โปรดเลือกข้อมูลที่ต้องการลบ!",
        "confirmBatchDelete": "ยืนยันการลบชุด?",
        "pleaseInputName": "โปรดป้อนชื่อ",
        "detailSetting": "การตั้งค่าละเอียด",
        "weekPlan": "แผนรายสัปดาห์",
        "specialDateSetting": "การตั้งค่าวันที่พิเศษ",
        "weekdayInfo": "วันในสัปดาห์เป็นสิ่งจำเป็น!",
        "volumeInfo": "ระดับเสียงเป็นสิ่งจำเป็น!",
        "timeError": "การเลือกวันเวลาผิดพลาด!",
        "editSuccess": "การแก้ไขสำเร็จ!",
        "addSuccess": "การเพิ่มสำเร็จ!",
        "addSpecialPlan": "เพิ่มแผนกลยุทธ์พิเศษ",
        "downloadSpeedInfo": "ความเร็วดาวน์โหลด: (0 หมายถึงห้ามดาวน์โหลด)",
        "pleaseSelectStartTime": "โปรดเลือกเวลาเริ่มต้น",
        "pleaseSelectEndTime": "โปรดเลือกเวลาสิ้นสุด",
        "luminanceError": "โปรดป้อนค่าความสว่างที่ถูกต้อง!",
        "defaultLuminance": "ความสว่างเริ่มต้น",
        "luminance": "ระดับความสว่าง",
        "defaultLuminanceInfo": "ความสว่างเริ่มต้น (100 หมายถึงสว่างที่สุด 0 หมายถึงมืดที่สุด)",
        "volume": "ระดับเสียง",
        "saveLuminance": "บันทึกความสว่าง",
        "changeSuccess": "เปลี่ยนสำเร็จ!",
        "changeNetwork": "เปลี่ยนเครือข่าย",
        "netName": "ชื่อเครือข่าย",
        "nameempty": "ชื่อเครือข่ายห้ามว่างเปล่า",
        "currentNetwork": "เครือข่ายปัจจุบัน",
        "ipAddress": "ที่อยู่ IP",
        "dailyMode": "โหมดทุกวัน",
        "weeklyMode": "โหมดรายสัปดาห์",
        "turnOnTime": "เวลาเปิดเครื่อง",
        "turnOffTime": "เวลาปิดเครื่อง",
        "startSleep": "เริ่มเข้าสู่โหมดหลับ",
        "endSleep": "สิ้นสุดโหมดหลับ",
        "batchDelInfo": "ยืนยันการลบรายการที่เลือก?",
        "timeCannotBeEmpty": "เวลาห้ามว่างเปล่า!",
        "startUp": "เปิดเครื่อง",
        "shutDown": "ปิดเครื่อง",
        "volumeSize": "ระดับเสียง",
        "defaultVolume": "ระดับเสียงเริ่มต้น (100 หมายถึงมากที่สุด 0 หมายถึงปิดเสียง)",
        "chooseStartTime": "โปรดเลือกเวลาเริ่มต้น",
        "chooseEndTime": "โปรดเลือกเวลาสิ้นสุด",
        "saveVolume": "บันทึกระดับเสียง",
        "screenRotationUnSaved": "การหมุนหน้าจอไม่ได้บันทึก",
        "volumeSettingUnSaved": "การตั้งค่าระดับเสียงไม่ได้บันทึก",
        "luminanceSettingUnSaved": "การตั้งค่าความสว่างไม่ได้บันทึก",
        "confirmClosePopup": "ยืนยันปิดป๊อปอัพนี้?",
        "volumeSettingSuccess": "เปลี่ยนระดับเสียงสำเร็จ",
        "luminanceSettingSuccess": "เปลี่ยนความสว่างสำเร็จ",
        "advancedSettingUnSaved": "การตั้งค่าเพิ่มเติมไม่ได้บันทึก",
        "settingTitle": "การตั้งค่าเทอร์มินัล",
        "volumeSetting": "การตั้งค่าระดับเสียง",
        "luminanceSetting": "การตั้งค่าความสว่าง",
        "downloadSetting": "การตั้งค่าดาวน์โหลด",
        "sleepSetting": "การตั้งค่าโหมดหลับ",
        "onOffSetting": "เปิด/ปิดเครื่องตามกำหนดเวลา",
        "screenRotation": "การหมุนหน้าจอ",
        "namingError": "ข้อผิดพลาดในการตั้งชื่อ ชื่อไฟล์ไม่สามารถมีช่องว่างได้!",
        "deleteSuccess": "ลบสำเร็จ",
        "deleteFolder": "ลบโฟลเดอร์",
        "pleaseInputDeviceName": "โปรดป้อนชื่ออุปกรณ์",
        "pleaseInputDeviceId": "โปรดป้อน ID อุปกรณ์",
        "discoverDevice": "ค้นพบอุปกรณ์",
        "deviceId": "ID อุปกรณ์",
        "bound": "ได้ผูกแล้ว",
        "bind": "ผูก",
        "noDevice": "ไม่มีอุปกรณ์",
        "refresh": "รีเฟรช",
        "manualAdd": "เพิ่มด้วยตนเอง",
        "deviceGroup": "หมวดหมู่อุปกรณ์",
        "pleaseSelectGroup": "โปรดเลือกกลุ่ม!",
        "deviceName": "ชื่ออุปกรณ์",
        "goAdd": "ไปเพิ่ม",
        "close": "ปิด",
        "bindCountInsufficient": "จำนวนที่สามารถผูกได้ไม่เพียงพอ โปรดอัปเกรดจำนวนอุปกรณ์แล้วเพิ่ม!",
        "displayNumber": "หมายเลขแสดง",
        "groupName": "ชื่อกลุ่ม",
        "pleaseSelectGroupName": "โปรดกรอกชื่อกลุ่ม!",
        "moveGroup": "ย้ายกลุ่ม",
        "longitude": "ลองจิจูด",
        "latitude": "ละติจูด",
        "nationality": "สัญชาติ",
        "province": "จังหวัด",
        "city": "เมือง",
        "county": "อำเภอ",
        "outNetIp": "IP เน็ตเวิร์กภายนอก",
        "inNetIp": "IP เน็ตเวิร์กภายใน",
        "companyName": "ชื่อบริษัท",
        "Info": "รายละเอียด",
        "android": "Android",
        "win": "Windows",
        "osVersion": "เวอร์ชันระบบปฏิบัติการ",
        "softwareVersion": "เวอร์ชันซอฟต์แวร์",
        "diskSize": "ขนาดดิสก์",
        "useSize": "ขนาดที่ใช้แล้ว",
        "macAddr": "ที่อยู่ MAC",
        "longitudeLatitudeInfo": "ลองจิจูดและละติจูดต้องว่างเปล่าหรือไม่ว่างเปล่าพร้อมกัน!",
        "terminalName": "ชื่อเทอร์มินัล",
        "terminalGroup": "กลุ่มเทอร์มินัล",
        "reportJournal": "รายงานหรือไม่",
        "systemVersion": "เวอร์ชันระบบ",
        "storageSpace": "พื้นที่จัดเก็บ",
        "resolution": "ความละเอียด",
        "runningMemory": "หน่วยความจำที่ใช้งานอยู่",
        "model": "รุ่น",
        "registerStatus": "สถานะการลงทะเบียน",
        "password": "รหัสผ่าน",
        "passwordInfo": "โปรดป้อนคำหรือตัวเลข 6 ถึง 18 ตัว!",
        "group": "กลุ่ม",
        "address": "ที่อยู่",
        "remark": "หมายเหตุ",
        "renewalPeriod": "ช่วงเวลาขยายอายุ",
        "money": "ค่าใช้จ่าย",
        "latitudeInfo": "โปรดป้อนละติจูดที่ถูกต้อง!",
        "totalPayment": "ยอดเงินรวม",
        "longitudeInfo": "โปรดป้อนลองจิจูดที่ถูกต้อง!",
        "setMeal": "แพ็คเกจ",
        "number": "จำนวน",
        "programName": "ชื่อโปรแกรม",
        "playStatus": "สถานะการเล่น",
        "playType": "วิธีการเล่น",
        "play": "เล่น",
        "pause": "หยุดชั่วคราว",
        "playTime": "เวลาเล่น",
        "programDeleted": "โปรแกรมถูกลบแล้ว",
        "playSuccess": "โปรแกรมได้ถูกจัดการให้เล่นแล้ว",
        "pauseSuccess": "หยุดชั่วคราวสำเร็จ",
        "playCycle": "เล่นวนรอบ",
        "playInsert": "แทรกเล่น",
        "withdrawSuccess": "ถอนสำเร็จ",
        "withdrawInfo": "โปรดเลือกโปรแกรมที่ต้องการถอนก่อน!",
        "programBelong": "โปรแกรมที่สังกัด",
        "checkAll": "เลือกทั้งหมด",
        "batchDel": "ลบชุด",
        "delConfirm": "ยืนยันการลบรายการที่เลือก?",
        "check": "เลือก",
        "noProgram": "ไม่มีโปรแกรม",
        "details": "รายละเอียด",
        "screenshotFail": "ถ่ายหน้าจอล้มเหลว",
        "policyName": "ชื่อวิธีการ",
        "terminalNum": "จำนวนเทอร์มินัลที่เชื่อมโยง",
        "powerStrategy": "กลยุทธ์พลังงาน",
        "pleaseSelectDepartment": "โปรดเลือกแผนก!",
        "screenshotControl": "ควบคุมการถ่ายหน้าจอ",
        "未激活": "ยังไม่เปิดใช้งาน",
        "已激活": "เปิดใช้งานแล้ว",
        "未绑定": "ยังไม่ผูก",
        "已绑定": "ได้ผูกแล้ว"
    },
    "programManage": {
        "programList": "รายการโปรแกรม",
        "publishProgram": "ติดตามการเผยแพร่โปรแกรม",
        "week1": "วันจันทร์",
        "week2": "วันอังคาร",
        "week3": "วันพุธ",
        "week4": "วันพฤหัสบดี",
        "week5": "วันศุกร์",
        "week6": "วันเสาร์",
        "week7": "วันอาทิตย์",
        "monday": "วันจันทร์",
        "tuesday": "วันอังคาร",
        "wednesday": "วันพุธ",
        "thursday": "วันพฤหัสบดี",
        "friday": "วันศุกร์",
        "saturday": "วันเสาร์",
        "sunday": "วันอาทิตย์",
        "name": "ชื่อ",
        "preview": "ดูตัวอย่าง",
        "playDeviceNum": "จำนวนอุปกรณ์เล่น",
        "copyDeviceCode": "คลิกเพื่อคัดลอก",
        "osType": "ประเภทระบบปฏิบัติการ",
        "playDate": "วันที่เล่น",
        "playWeek": "สัปดาห์ที่เล่น",
        "everyday": "ทุกวัน",
        "start": "เริ่ม",
        "end": "สิ้นสุด",
        "playOperateStatusStr": "สถานะการเผยแพร่",
        "playDevice": "อุปกรณ์เล่น",
        "downloadView": "ดูการดาวน์โหลด",
        "publisher": "ผู้เผยแพร่",
        "publishTime": "เวลาเผยแพร่",
        "operation": "การดำเนินการ",
        "add": "เพิ่ม",
        "groupName": "ชื่อกลุ่ม",
        "selectDevice": "เลือกเทอร์มินัล",
        "searchDevice": "ค้นหาเทอร์มินัล",
        "pleaseFillGroupName": "โปรดกรอกชื่อกลุ่ม!",
        "remarkInfo": "หมายเหตุ",
        "compile": "แก้ไข",
        "withdrawConfirm": "ยืนยันการถอนโปรแกรมนี้?",
        "confirm": "ยืนยัน",
        "cancel": "ยกเลิก",
        "withdraw": "ถอน",
        "batchWithdraw": "ถอนชุด",
        "batchPublish": "เผยแพร่ชุด",
        "batchDelete": "ลบชุด",
        "batchOperation": "การดำเนินการชุด",
        "notUse": "ยังไม่ใช้",
        "notChecked": "ยังไม่ตรวจสอบ",
        "notPass": "ไม่ผ่าน",
        "delete": "ลบ",
        "publishTextLeft": "ได้เผยแพร่แล้ว",
        "offTextLeft": "ได้หยุดชั่วคราวแล้ว",
        "pleaseSelectProgramToMove": "โปรดเลือกโปรแกรมที่ต้องการย้าย!",
        "pause": "หยุดชั่วคราว",
        "pauseConfirm": "ยืนยันการหยุดชั่วคราว?",
        "play": "เล่น",
        "downloadUdisk": "ดาวน์โหลดไปยัง USB Flash Drive",
        "deviceList": "รายการอุปกรณ์",
        "groupSelection": "การเลือกกลุ่ม",
        "operationSuccess": "ดำเนินการสำเร็จ",
        "deleteSuccess": "ลบสำเร็จ",
        "selectDate": "เลือกวันที่",
        "publishStatus": "สถานะการเผยแพร่",
        "checkStatus": "สถานะการตรวจสอบ",
        "waitAuditing": "รอการตรวจสอบ",
        "auditPass": "ผ่านการตรวจสอบ",
        "auditRefuse": "ปฏิเสธการตรวจสอบ",
        "all": "ทั้งหมด",
        "playStatus": "กำลังเล่น",
        "playStatust": "สถานะการเล่น",
        "pauseStatus": "หยุดชั่วคราวแล้ว",
        "notStartStatus": "ยังไม่เริ่ม",
        "resolutionratio": "ความละเอียด",
        "totalNum": "รายการ",
        "programName": "ชื่อโปรแกรม",
        "playStartTime": "เวลาเริ่มเล่น",
        "playEndTime": "เวลาสิ้นสุดการเล่น",
        "createTime": "เวลาสร้าง",
        "nationality": "สัญชาติ",
        "province": "จังหวัด",
        "city": "เมือง",
        "county": "อำเภอ",
        "address": "ที่อยู่",
        "ip": "ที่อยู่ IP",
        "location": "ตำแหน่ง",
        "log": "บันทึก",
        "pleaseFillProgramName": "โปรดกรอกชื่อโปรแกรม!",
        "selectGroup": "เลือกกลุ่ม",
        "startTime": "เวลาเริ่มต้น",
        "endTime": "เวลาสิ้นสุด",
        "publishCycle": "รอบการเผยแพร่",
        "publishDeviceNum": "จำนวนอุปกรณ์ที่เผยแพร่",
        "pleaseSelectRecord": "โปรดเลือกบันทึก",
        "deviceName": "ชื่อเทอร์มินัล",
        "deviceId": "ID อุปกรณ์เทอร์มินัล",
        "deviceGroupIdName": "กลุ่มที่อยู่",
        "notClassified": "ยังไม่จัดหมวดหมู่",
        "osTypeStr": "ระบบปฏิบัติการเทอร์มินัล",
        "storageSpace": "พื้นที่จัดเก็บ",
        "onLineStatus": "สถานะออนไลน์",
        "onLine": "ออนไลน์",
        "offLine": "ออฟไลน์",
        "sleep": "หลับ",
        "unknown": "ไม่ทราบ",
        "registerStatus": "สถานะการลงทะเบียน",
        "trialPeriod": "ระยะเวลาปรึกษา",
        "notActive": "ยังไม่เปิดใช้งาน",
        "active": "เปิดใช้งานแล้ว",
        "parameterError": "พารามิเตอร์ผิดพลาด!",
        "pleaseSelectProgram": "โปรดเลือกโปรแกรม!",
        "pleaseSelectProgramEdit": "โปรดเลือกโปรแกรมที่จะแก้ไข!",
        "confirmWithdrawSelectedProgram": "ยืนยันการถอนโปรแกรมที่เลือก?",
        "withdrawSuccess": "ถอนสำเร็จ",
        "allPrograms": "โปรแกรมทั้งหมด",
        "defaultGroup": "กลุ่มเริ่มต้น",
        "cannotShareEmptyProgram": "ไม่สามารถแชร์โปรแกรมว่างเปล่าได้!",
        "onlyShareYourProgram": "สามารถแชร์เฉพาะโปรแกรมที่คุณสร้างเท่านั้น!",
        "pleaseSelectProgramEditPublishTime": "โปรดเลือกโปรแกรมที่ได้แก้ไขเวลาเผยแพร่แล้ว!",
        "pleaseSelectDevice": "โปรดเลือกอุปกรณ์!",
        "programDetail": "รายละเอียดโปรแกรม",
        "errorReason": "เหตุผลของข้อผิดพลาด",
        "availableStorageSpaceInsufficient": "พื้นที่จัดเก็บที่ใช้ได้ไม่เพียงพอ",
        "partialDeviceReleaseFailure": "การเผยแพร่บางส่วนของอุปกรณ์ล้มเหลว",
        "allDeviceReleaseSuccess": "การเผยแพร่อุปกรณ์ทั้งหมดสำเร็จ",
        "partialDeviceReleaseSuccess": "การเผยแพร่บางส่วนของอุปกรณ์สำเร็จ",
        "allGroup": "กลุ่มทั้งหมด",
        "allProgram": "โปรแกรมทั้งหมด",
        "unGrouped": "ยังไม่ได้จัดกลุ่ม",
        "replaceProgram": "แทนที่โปรแกรม",
        "replaceProgramTip": "โปรแกรมที่เผยแพร่ใหม่จะแทนที่ข้อมูลโปรแกรมที่ส่งไปยังเทอร์มินัลเล่นเดิม!",
        "screen": "หน้าจอเดี่ยว/คู่",
        "singleScreen": "หน้าจอเดี่ยว",
        "doubleScreen": "หน้าจอคู่",
        "playSetting": "การตั้งค่าเล่น",
        "batchPlaySetting": "ตั้งค่าเวลาเล่นชุด",
        "individualPlaySetting": "ตั้งค่าเวลาเล่นรายการ",
        "playTime": "เวลาเล่น",
        "daily": "ทุกวัน",
        "weekdays": "วันจันทร์ถึงวันศุกร์",
        "monthly": "เดือนนี้",
        "advancedSetting": "การตั้งค่าเพิ่มเติม",
        "playProgram": "เล่นโปรแกรม",
        "searchProgram": "โปรดป้อนคำค้นหา",
        "shareAddressNotExist": "ที่อยู่ลิงก์ไม่มีอยู่ โปรดลองอีกครั้ง",
        "copySuccess": "คัดลอกสำเร็จ",
        "shareLink": "ลิงก์แชร์",
        "publish": "เผยแพร่",
        "noResource": "ไม่มีทรัพยากร",
        "single": "หน้าจอเดี่ยว",
        "double": "หน้าจอคู่",
        "time": "เวลา",
        "associatedTerminalNum": "จำนวนเทอร์มินัลที่เชื่อมโยง",
        "default": "เริ่มต้น",
        "moveGroup": "ย้ายกลุ่ม",
        "pleaseSelectGroup": "โปรดกรอกชื่อกลุ่ม!",
        "copy": "คัดลอก",
        "FUBEN": "สำเนา",
        "nameempty": "ชื่อห้ามว่างเปล่า",
        "whitespace": "ข้อผิดพลาดในการตั้งชื่อ ชื่อไฟล์ไม่สามารถมีช่องว่างได้!",
        "programWhitespace": "ข้อผิดพลาดในการตั้งชื่อ ชื่อโปรแกรมไม่สามารถมีช่องว่างได้!",
        "pleaseSelectResolution": "โปรดเลือกความละเอียด!",
        "dataError": "ข้อมูลผิดพลาด!",
        "createProgram": "สร้างโปรแกรมใหม่",
        "directCreate": "สร้างโดยตรง",
        "myTemplate": "เทมเพลตของฉัน",
        "use": "ใช้",
        "free": "ฟรี",
        "loadMore": "โหลดเพิ่มเติม",
        "confirmDelete": "ยืนยันการลบ",
        "deleteGroup": "ลบกลุ่ม",
        "notPublished": "ยังไม่เผยแพร่",
        "notPassed": "ไม่ผ่าน",
        "notUsed": "ยังไม่ใช้",
        "confirmDeleteSelectedProgram": "ยืนยันการลบโปรแกรมที่เลือก?",
        "companyName": "ชื่อบริษัท",
        "programCannotDownload": "ไม่สามารถดาวน์โหลดโปรแกรมนี้ได้!",
        "publishMaterial": "เผยแพร่วัสดุ",
        "playMaterial": "เล่นวัสดุ",
        "pleaseInputMaterialName": "โปรดป้อนชื่อวัสดุ",
        "size": "ขนาด",
        "pleaseInputDeviceName": "โปรดป้อนชื่ออุปกรณ์",
        "item": "รายการ",
        "allMaterial": "วัสดุทั้งหมด",
        "allDevices": "อุปกรณ์ทั้งหมด",
        "saveSuccess": "บันทึกสำเร็จ",
        "savefaill": "บันทึกไม่สำเร็จ",
        "playMode": "โหมดเล่น",
        "cyclePlay": "เล่นวนซ้ำ",
        "insertPlay": "แทรกเล่น",
        "noData": "ไม่มีข้อมูล",
        "Add": "เพิ่มใหม่",
        "replace": "แทนที่",
        "repeat": "ซ้ำ",
        "start01": "เริ่ม",
        "end01": "สิ้นสุด",
        "startDate": "วันที่เริ่มต้น",
        "endDate": "วันที่สิ้นสุด",
        "useNow": "ใช้งานทันที",
        "fillStartEndTimeFirst": "กรุณากรอกเวลาเริ่มต้นและสิ้นสุดก่อนเพิ่ม",
        "fillFullPlayTime": "กรุณากรอกเวลาเล่นให้ครบถ้วน",
        "fillCorrectPlayTime": "กรุณากรอกช่วงเวลาเล่นให้ถูกต้อง",
        "sDateAndEDateBothEmptyOrFilled": "วันที่เริ่มต้นและวันที่สิ้นสุดต้องว่างทั้งคู่หรือกรอกทั้งคู่"
    },
    "source": {
        "addResource": "เพิ่มทรัพยากร",
        "width": "ความกว้าง",
        "height": "ความสูง",
        "size": "ขนาด (KB)",
        "name": "ชื่อ",
        "pleaseInputResourceName": "โปรดป้อนชื่อทรัพยากร!",
        "addToGroup": "เพิ่มเข้ากลุ่ม",
        "remark": "หมายเหตุ",
        "promptFgIllustrate": "ภาพวาด",
        "promptFgRealisticPhoto": "ภาพถ่ายแบบเรียลistycz์",
        "promptFgSimplisticDrawing": "ภาพวาดง่าย",
        "promptFgChineseStyle": "สไตล์จีน",
        "promptFgPixelArt": "สไตล์พิกเซล",
        "noModel": "ไม่มีโมเดล โปรดติดต่อผู้ดูแลระบบ!",
        "getModelFailed": "ไม่สามารถรับโมเดลได้ โปรดลองอีกครั้งในภายหลัง! หรือติดต่อผู้ดูแลระบบ!",
        "createImagePrompt": "กำลังสร้างภาพ โปรดอย่าปิด!",
        "promptEmpty": "โปรดป้อนคำบอก",
        "dpiEmpty": "โปรดเลือกอัตราส่วนภาพ!",
        "fgEmpty": "โปรดเลือกสไตล์!",
        "style": "สไตล์",
        "idEmpty": "ID ภาพห้ามว่างเปล่า",
        "exist": "ภาพนี้มีอยู่ในวัสดุแล้ว",
        "addSuccess": "เพิ่มวัสดุสำเร็จ",
        "saveError": "ไม่สามารถบันทึกภาพได้ โปรดลองอีกครั้งในภายหลัง!",
        "delSuccess": "ลบสำเร็จ",
        "generateImage": "ข้อความเป็นภาพ",
        "generateImagePlaceholder": "โปรดป้อนภาพที่คุณต้องการสร้าง เช่น: ผีเสื้อหนึ่งตัวกำลังเต้นรำในทุ่งดอกไม้",
        "aiExpand": "ขยายด้วยปัญญาประดิษฐ์",
        "negativePrompt": "คำบอกลบ",
        "negativePromptTooltip": "ใช้สำหรับกำหนดชัดเจนเนื้อหาหรือลักษณะที่ผู้ใช้ไม่ต้องการให้ปรากฏในผลลัพธ์",
        "imageRatio": "อัตราส่วนภาพ",
        "generateImageBtn": "สร้างทันที",
        "shengchengjieguo": "ผลลัพธ์การสร้าง",
        "generateImageLoadingTip": "กำลังสร้างอยู่ อย่าคลิกซ้ำหรือปิด...",
        "Tooltip": "มาใช้ปัญญาประดิษฐ์สร้างไอเดียของคุณกัน",
        "saveToMaterial": "บันทึกเป็นวัสดุ",
        "publish": "เผยแพร่ทันที",
        "download": "ดาวน์โหลด",
        "generateHistory": "ประวัติการสร้าง",
        "hide": "ซ่อน",
        "cancel": "ยกเลิก",
        "useExpand": "ใช้การขยาย",
        "all": "ทั้งหมด",
        "delete": "ลบ",
        "loadMore": "โหลดเพิ่มเติม",
        "aiTip": "เนื้อหาถูกสร้างโดยโมเดลปัญญาประดิษฐ์ ไม่เป็นตัวแทนของมุมมอง、ตำแหน่งหรือทัศนคติของแพลตฟอร์ม โปรดใช้เนื้อหา AI ตามกฎและข้อกำหนดที่ถูกต้อง",
        "operationSuccess": "ดำเนินการสำเร็จ",
        "moveGroup": "ย้ายกลุ่ม",
        "groupName": "ชื่อกลุ่ม",
        "pleaseSelectGroup": "โปรดเลือกชื่อกลุ่ม!",
        "shenhe": "ตรวจสอบ",
        "shenheStatus": "สถานะการตรวจสอบ",
        "shenheSuccess": "ผ่านการตรวจสอบ",
        "shenheRefuse": "ปฏิเสธการตรวจสอบ",
        "pleaseSelectShenheStatus": "โปรดเลือกสถานะการตรวจสอบ!",
        "shenheRemark": "หมายเหตุการตรวจสอบ",
        "pleaseInputShenheRemark": "โปรดป้อนหมายเหตุการตรวจสอบ!",
        "pleaseInputFileName": "โปรดป้อนชื่อไฟล์!",
        "whitespace": "ข้อผิดพลาดในการตั้งชื่อ ชื่อไฟล์ไม่สามารถมีช่องว่างได้!",
        "dataError": "ข้อมูลผิดพลาด!",
        "confirmDelete": "ยืนยันการลบ",
        "confirm": "ยืนยัน",
        "deleteFolder": "ลบโฟลเดอร์",
        "add": "เพิ่ม",
        "edit": "แก้ไข",
        "fileName": "ชื่อไฟล์",
        "group": "กลุ่ม",
        "resolution": "ความละเอียด",
        "type": "ประเภท",
        "image": "ภาพ",
        "music": "เพลง",
        "video": "วิดีโอ",
        "uploadTime": "เวลาอัปโหลด",
        "uploadUser": "ผู้อัปโหลด",
        "checkTime": "เวลาการตรวจสอบ",
        "checkUser": "ผู้ตรวจสอบ"
    },
    "setting": {
        "nameempty": "ชื่อห้ามว่างเปล่า",
        "heightempty": "ความสูงห้ามว่างเปล่า",
        "widthempty": "ความกว้างห้ามว่างเปล่า",
        "resolutionratio": "ความละเอียด",
        "name": "ชื่อ",
        "opteration": "การดำเนินการ",
        "compile": "แก้ไข",
        "delete": "ลบ",
        "newz": "เพิ่มใหม่",
        "compileratio": "แก้ไขความละเอียด",
        "sheizhifenbianlvmingcheng": "ตั้งชื่อความละเอียด",
        "shezhigaodu": "ตั้งความสูง",
        "shezhikuandu": "ตั้งความกว้าง",
        "xinzengfenbianlv": "เพิ่มความละเอียดใหม่",
        "bianma": "รหัส",
        "bianjizhongduanmingcheng": "แก้ไขชื่อเทอร์มินัล",
        "xinzengzhongduan": "เพิ่มเทอร์มินัลใหม่",
        "selectPrimaryColor": "เลือกสีธีม",
        "fullScreen": "เต็มหน้าจอ",
        "exitFullScreen": "ออกจากโหมดเต็มหน้าจอ"
    },
    "tabs": {
        "refresh": "รีเฟรช",
        "refreshAll": "รีเฟรชทั้งหมด",
        "close": "ปิด",
        "closeOthers": "ปิดอื่นๆ",
        "closeAll": "ปิดทั้งหมด",
        "closeLeft": "ปิดด้านซ้าย",
        "closeRight": "ปิดด้านขวา"
    },
    "errorPage": {
        "needLogin": "คุณยังไม่ได้เข้าสู่ระบบ!",
        "pageNotFound": "หน้าที่คุณเข้าถึงไม่มีอยู่!",
        "redirectTo": "เปลี่ยนเส้นทางไปยัง",
        "orReturn": "หรือกลับไปที่",
        "previousStep": "ขั้นตอนก่อนหน้า"
    },
    "headerUs": {
        "systemNotice": "แจ้งเตือนระบบ",
        "allNotices": "แจ้งเตือนทั้งหมด",
        "viewAllMessages": "ดูข้อความทั้งหมด",
        "contactUs": "ติดต่อเรา",
        "operationSuccess": "ดำเนินการสำเร็จ!",
        "leaveMessage": "ฉันต้องการส่งข้อความ",
        "messageTitle": "หัวข้อ",
        "messageTitleTip": "โปรดป้อนหัวข้อ!",
        "messageContentTip": "ไม่เกิน 150 ตัวอักษร",
        "submit": "ส่ง",
        "markAsRead": "ทำเครื่องหมายว่าเป็นอ่านแล้ว",
        "success": "ดำเนินการสำเร็จ!"
    },
    "material": {
        "allMaterial": "วัสดุทั้งหมด",
        "defaultGroup": "กลุ่มเริ่มต้น",
        "auditStatus": "สถานะการตรวจสอบ",
        "auditPassed": "ผ่านการตรวจสอบ",
        "auditRejected": "ปฏิเสธการตรวจสอบ",
        "pendingAudit": "รอการตรวจสอบ",
        "all": "ทั้งหมด",
        "operateSuccess": "ดำเนินการสำเร็จ!",
        "pleaseSelectMaterial": "โปรดเลือกวัสดุ!",
        "moveGroup": "ย้ายกลุ่ม",
        "pleaseSelectGroup": "โปรดเลือกกลุ่ม!",
        "batchPublish": "เผยแพร่ชุด",
        "batchRecall": "ถอนชุด",
        "batchDelete": "ลบชุด",
        "materialList": "รายการวัสดุ",
        "uploadMaterial": "อัปโหลดวัสดุ",
        "materialType": "ประเภทวัสดุ",
        "pleaseInputMaterialName": "โปรดป้อนชื่อวัสดุ",
        "selectAll": "เลือกทั้งหมด",
        "confirmDeleteSelectedMaterial": "ยืนยันการลบวัสดุที่เลือก?",
        "deleteSuccess": "ลบสำเร็จ",
        "delete": "ลบ",
        "publish": "เผยแพร่",
        "recall": "ถอน",
        "confirmRecallSelectedMaterial": "ยืนยันการถอนวัสดุที่เลือก?",
        "pleaseSelectMaterialGroup": "โปรดเลือกกลุ่มวัสดุ!",
        "recallSuccess": "ถอนสำเร็จ",
        "publishSuccess": "เผยแพร่สำเร็จ",
        "batchOperate": "ดำเนินการชุด",
        "item": "รายการ",
        "confirmDelete": "ยืนยันการลบ?",
        "edit": "แก้ไข",
        "confirmRecall": "ยืนยันการถอน?",
        "unaudited": "ยังไม่ตรวจสอบ",
        "notPassed": "ไม่ผ่าน",
        "operate": "ดำเนินการ",
        "resolution": "ความละเอียด",
        "none": "ไม่มี",
        "confirm": "ยืนยัน",
        "cancel": "ยกเลิก",
        "AICreation": "สร้างด้วย AI"
    },
    "uploadFile": {
        "operationSuccess": "ดำเนินการสำเร็จ",
        "uploadFile": "จัดการอัปโหลด",
        "uploadSuccess": "อัปโหลดสำเร็จ",
        "uploadCompleted": "อัปโหลดเสร็จสิ้น",
        "uploadFail": "อัปโหลดล้มเหลว",
        "ConversionFailed": "การแปลงล้มเหลว!",
        "loading": "กำลังโหลด...",
        "beQueuing": "อยู่ในคิว...",
        "Uploading": "กำลังอัปโหลด...",
        "ConversionIng": "กำลังแปลง...",
        "ConventionalResources": "ทรัพยากรปกติ",
        "DocumentResources": "ทรัพยากรเอกสาร",
        "complete": "เสร็จสิ้น",
        "upload": "อัปโหลด",
        "fileSizeWraning01": "ขนาดวัสดุเกิน",
        "fileSizeWraning02": "โปรดแก้ไขแล้วอัปโหลดใหม่!",
        "fileIsEmpty": "ไฟล์ว่างเปล่า",
        "uploadFileTip": "รูปแบบไฟล์ที่ไม่รองรับ",
        "unablePreview": "ไม่ได้เพิ่มลงในคลังวัสดุสำเร็จ ไม่สามารถดูตัวอย่างได้",
        "confirmDelete": "ยืนยันการลบ?",
        "deleteSuccess": "ลบสำเร็จ",
        "delete": "ลบ",
        "confirm": "ยืนยัน",
        "preview": "ดูตัวอย่าง",
        "close": "ปิด",
        "cancel": "ยกเลิก",
        "fileType": "ประเภทไฟล์",
        "fileSize": "ขนาดไฟล์",
        "conversionProgress": "ความคืบหน้าการแปลง",
        "progress": "ความคืบหน้า",
        "image": "ภาพ",
        "video": "วิดีโอ",
        "audio": "เสียง",
        "limitTip01": "อัปโหลดครั้งละ",
        "limitTip02": "ไฟล์",
        "okTip": "กำลังอัปโหลดวัสดุ โปรดอย่าปิดในขณะนี้!",
        "usableSize": "พื้นที่จัดเก็บที่ใช้ได้",
        "sizeUnableTip": "พื้นที่จัดเก็บที่ใช้ได้ในปัจจุบันไม่เพียงพอ โปรดล้างวัสดุที่ไม่จำเป็นเพื่อประหยัดพื้นที่ หรือติดต่อตัวแทนขายเพื่อขยายพื้นที่จัดเก็บ.",
        "view": "ดูรายละเอียด",
        "fileName": "ชื่อไฟล์"
    },
    "template": {
        "inputPlaceholder": "โปรดป้อน",
        "selectPlaceholder": "โปรดเลือก",
        "noAuths": "ไม่มีสิทธิ์ โปรดติดต่อผู้ดูแลระบบ",
        "operationSuccess": "ดำเนินการสำเร็จ",
        "total": "ทั้งหมด",
        "totalNum": "รายการ",
        "dan": "เดี่ยว",
        "shaung": "คู่",
        "pleaseSelectGroup": "โปรดเลือกกลุ่ม",
        "preview": "ดูตัวอย่าง",
        "free": "ฟรี",
        "use": "ใช้",
        "dpi": "ความละเอียด",
        "delete": "ลบ",
        "confirmDelete": "ยืนยันการลบ",
        "confirmDeleteSelectedTemplate": "ยืนยันการลบเทมเพลตนี้?",
        "push": "เผยแพร่",
        "pushConfirm": "ยืนยันการเผยแพร่ไปยังเทมเพลตสาธารณะ?",
        "pushRemovalConfirm": "ยืนยันการถอดจากเทมเพลตสาธารณะ?",
        "templateOrderRecord": "บันทึกออเดอร์เทมเพลต",
        "unpublished": "ยังไม่เผยแพร่",
        "auditing": "กำลังตรวจสอบ",
        "publishRejected": "ปฏิเสธการเผยแพร่",
        "publishSuccess": "เผยแพร่สำเร็จ",
        "offShelf": "ถอดจากชั้น",
        "公共模版": "เทมเพลตสาธารณะ",
        "我的模板": "เทมเพลตของฉัน",
        "共享记录": "บันทึกการแชร์",
        "name": "ชื่อ",
        "pubdate": "เวลาเผยแพร่",
        "keySeachTip": "โปรดป้อนคำค้นหา",
        "allGroup": "กลุ่มทั้งหมด",
        "add": "เพิ่ม",
        "edit": "แก้ไข",
        "programName": "ชื่อโปรแกรม",
        "selectGroup": "เลือกกลุ่ม"
    },
    "checkManage": {
        "total": "ทั้งหมด",
        "totalNum": "รายการ",
        "operationSuccess": "ดำเนินการสำเร็จ",
        "checkUserLogs": "บันทึกการตรวจสอบ (ผู้ดำเนินการ)",
        "checkLogs": "บันทึกการตรวจสอบ (ผู้ตรวจสอบ)",
        "sourceCheck": "ตรวจสอบวัสดุ",
        "programCheck": "ตรวจสอบโปรแกรม",
        "checkAll": "เลือกทั้งหมด",
        "auditPass": "ผ่านการตรวจสอบ",
        "auditRefuse": "ปฏิเสธการตรวจสอบ",
        "auditPass01": "ผ่าน",
        "auditRefuse01": "ปฏิเสธ",
        "auditRefuse02": "ปฏิเสธการตรวจสอบ",
        "auditor": "ผู้ตรวจสอบ",
        "agentUserName": "ผู้เผยแพร่",
        "interrogationTime": "เวลาส่งตรวจสอบ",
        "checkTime": "เวลาการตรวจสอบ",
        "checkName": "ชื่อที่ตรวจสอบ",
        "checkType": "ประเภทการตรวจสอบ",
        "checkIp": "ที่อยู่ IP ส่งตรวจสอบ",
        "checkReason": "ข้อความแนบ",
        "checkStatus": "เนื้อหาการดำเนินการ",
        "rangePicker": "วันที่ตรวจสอบ",
        "keyWord": "คำค้นหา",
        "all": "ทั้งหมด",
        "program": "โปรแกรม",
        "material": "วัสดุ",
        "dan": "เดี่ยว",
        "shaung": "คู่",
        "pleaseSelectProgram": "โปรดเลือกโปรแกรม!",
        "pleaseSelectMaterial": "โปรดเลือกวัสดุ!",
        "preview": "ดูตัวอย่าง",
        "dpi": "ความละเอียด",
        "auditRefuseTip": "โปรดป้อนเหตุผลการปฏิเสธ",
        "unreviewed": "ยังไม่ตรวจสอบ",
        "notPassed": "ไม่ผ่าน",
        "notUsed": "ยังไม่ใช้",
        "edit": "แก้ไข",
        "none": "ไม่มี",
        "name": "ชื่อ",
        "size": "ขนาด",
        "type": "ประเภท",
        "uploadTime": "เวลาอัปโหลด",
        "uploadUser": "ผู้อัปโหลด",
        "checkUser": "ผู้ตรวจสอบ",
        "image": "ภาพ",
        "music": "เพลง",
        "video": "วิดีโอ"
    },
    "systemSet": {
        "total": "ทั้งหมด",
        "totalNum": "รายการ",
        "inputPlaceholder": "โปรดป้อน",
        "selectPlaceholder": "โปรดเลือก",
        "userList": "สมาชิกองค์กร",
        "roleList": "สิทธิ์บทบาท",
        "department": "โครงสร้างองค์กร",
        "diskInfo": "พื้นที่จัดเก็บ",
        "approveSet": "อนุมัติเนื้อหา",
        "logList": "จัดการบันทึก",
        "name": "ชื่อ",
        "account": "บัญชี",
        "userName": "ชื่อผู้ใช้",
        "phoneNumber": "หมายเลขโทรศัพท์มือถือ",
        "role": "บทบาท",
        "createTime": "เวลาสร้าง",
        "operation": "ดำเนินการ",
        "edit": "แก้ไข",
        "delete": "ลบ",
        "addNew": "เพิ่มใหม่",
        "add": "เพิ่ม",
        "resetPassword": "รีเซ็ตรหัสผ่าน",
        "confirmDelete": "ยืนยันการลบ",
        "departmentOrganization": "โครงสร้างแผนก",
        "addNewUser": "เพิ่มผู้ใช้ใหม่",
        "pleaseEnterUserName": "โปรดป้อนชื่อผู้ใช้",
        "confirmPasswordNotMatch": "รหัสผ่านยืนยันไม่ตรงกับรหัสผ่านที่ป้อน!",
        "operationSuccess": "ดำเนินการสำเร็จ!",
        "userNickname": "ชื่อผู้ใช้",
        "pleaseEnterUserNickname": "โปรดป้อนชื่อผู้ใช้",
        "userNicknameRequired": "ชื่อผู้ใช้ห้ามว่างเปล่า!",
        "password": "รหัสผ่าน",
        "pleaseEnterPassword": "โปรดป้อนรหัสผ่าน",
        "passwordRequired": "รหัสผ่านห้ามว่างเปล่า!",
        "passwordTip": "ความปลอดภัยของรหัสผ่านของคุณต่ำเกินไป (รหัสผ่านต้องประกอบด้วย 3 ประเภทใดๆ จากตัวอักษรพิมพ์ใหญ่、ตัวอักษรพิมพ์เล็ก、ตัวเลข、อักขระพิเศษ และมีความยาว 8",
        "confirmPassword": "ยืนยันรหัสผ่าน",
        "pleaseEnterPhoneNumber": "โปรดป้อนหมายเลขโทรศัพท์มือถือ",
        "phoneNumberRequired": "หมายเลขโทรศัพท์มือถือห้ามว่างเปล่า!",
        "phoneNumberFormatError": "โปรดป้อนหมายเลขโทรศัพท์มือถือที่ถูกต้อง!",
        "roleRequired": "บทบาทห้ามว่างเปล่า!",
        "required": "ห้ามว่างเปล่า!",
        "departmentName": "แผนก",
        "modifyPassword": "เปลี่ยนรหัสผ่าน",
        "newPassword": "รหัสผ่านใหม่",
        "pleaseEnterNewPassword": "โปรดป้อนรหัสผ่านใหม่",
        "pwdMessage": "รหัสผ่านต้องมีความยาว 8~20 ตัวอักษร ไม่สามารถมีช่องว่างได้ และต้องประกอบด้วย 3 ประเภทจากตัวอักษรพิมพ์ใหญ่、ตัวอักษรพิมพ์เล็ก、ตัวเลข、อักขระพิเศษ",
        "all": "ทั้งหมด",
        "noAuths": "ไม่มีสิทธิ์ โปรดติดต่อผู้ดูแลระบบ",
        "departmentName01": "ชื่อแผนก",
        "image": "ภาพ",
        "music": "เพลง",
        "video": "วิดีโอ",
        "buySize": "จำนวนที่ซื้อ",
        "totalMoney": "ยอดเงินที่ต้องชำระ",
        "buycreateTime": "เวลาซื้อ",
        "endTime": "เวลาหมดอายุ",
        "buyTypeStr": "ประเภทออเดอร์",
        "sourceCheck": "ตรวจสอบวัสดุ",
        "programCheck": "ตรวจสอบโปรแกรม",
        "programName": "ชื่อโปรแกรม",
        "diskExpansion": "แนะนำให้ล้างวัสดุที่หมดอายุ/ไม่ใช้ในระหว่างการใช้งาน เพื่อให้แน่ใจว่าพื้นที่จัดเก็บที่ใช้ได้ของระบบเพียงพอ หากคุณต้องการพื้นที่มากขึ้น คุณสามารถติดต่อผู้จำหน่ายอุปกรณ์เพื่อรับบริการขยายพื้นที่จัดเก็บคลาวด์ บริการนี้อาจมีค่าใช้จ่าย โปรดอ้างอิงข้อมูลจากตัวแทนขายเป็นหลัก.",
        "selectPermission": "โปรดเลือกสิทธิ์",
        "checkPermission": "โปรดติ๊กสิทธิ์",
        "addRole": "เพิ่มบทบาท",
        "enterRoleName": "โปรดป้อนชื่อบทบาท",
        "roleName": "ชื่อบทบาท",
        "roleNameRequired": "ชื่อบทบาทห้ามว่างเปล่า!",
        "remark": "หมายเหตุ",
        "enterRemark": "โปรดป้อนหมายเหตุ",
        "permissionSetting": "การตั้งค่าสิทธิ์",
        "deleteSuccess": "ลบสำเร็จ!",
        "confirmToDelete": "ยืนยันการลบ?",
        "orgName": "ชื่อองค์กร",
        "orgNameRequired": "ชื่อองค์กรห้ามว่างเปล่า!",
        "orgRemark": "หมายเหตุองค์กร",
        "enterOrgRemark": "โปรดป้อนหมายเหตุองค์กร",
        "capacityUsage": "สถานะการใช้พื้นที่จัดเก็บ",
        "usedCapacity": "พื้นที่จัดเก็บที่ใช้แล้ว",
        "totalCapacity": "พื้นที่จัดเก็บทั้งหมด",
        "remainingCapacity": "พื้นที่จัดเก็บที่เหลือ",
        "capacityExpansion": "ขยายพื้นที่จัดเก็บ",
        "enable": "เปิด",
        "disable": "ปิด",
        "userName01": "ชื่อผู้ใช้",
        "loginTime": "เวลาเข้าสู่ระบบ",
        "ipAddress": "ที่อยู่ IP",
        "loginResult": "ผลลัพธ์การเข้าสู่ระบบ",
        "selectDate": "เลือกวันที่",
        "enterDate": "โปรดเลือกวันที่",
        "selectStartTime": "โปรดเลือกเวลาเริ่มต้น",
        "selectEndTime": "โปรดเลือกเวลาสิ้นสุด",
        "enterUserName": "โปรดป้อนชื่อผู้ใช้",
        "userCount": "จำนวนผู้ใช้",
        "roleDesc": "คำอธิบายบทบาท",
        "roleAuthorization": "การมอบสิทธิ์บทบาท",
        "success": "สำเร็จ",
        "failure": "ล้มเหลว",
        "time": "เวลา",
        "operationContent": "เนื้อหาการดำเนินการ",
        "playCount": "จำนวนการเล่น",
        "playDuration": "ระยะเวลาการเล่น",
        "selectDevice": "เลือกอุปกรณ์",
        "enterProgramName": "โปรดป้อนชื่อโปรแกรม",
        "serialNumber": "หมายเลขลำดับ",
        "publishContentName": "ชื่อเนื้อหาที่เผยแพร่",
        "playMode": "วิธีการเล่น",
        "cyclePlay": "เล่นวนรอบ",
        "insertPlay": "แทรกเล่น",
        "paddingPlay": "เล่นเติม",
        "playDeviceId": "ID อุปกรณ์เล่น",
        "playDeviceName": "ชื่ออุปกรณ์เล่น",
        "publishTime": "เวลาเผยแพร่",
        "downloadStatus": "สถานะการดาวน์โหลด",
        "notDownloaded": "ยังไม่ดาวน์โหลด",
        "downloading": "กำลังดาวน์โหลด",
        "downloadSucceeded": "ดาวน์โหลดสำเร็จ",
        "downloadFailed": "ดาวน์โหลดล้มเหลว",
        "enterPublishContentName": "โปรดป้อนชื่อเนื้อหาที่เผยแพร่",
        "terminalId": "ID เทอร์มินัล",
        "belongOrg": "องค์กรที่สังกัด",
        "reportTime": "เวลารายงาน",
        "reportIp": "IP ที่รายงาน",
        "logInfo": "ข้อมูลบันทึก",
        "details": "รายละเอียด",
        "confirmDeletion": "ยืนยันการลบ?",
        "logDetails": "รายละเอียดบันทึก",
        "download": "ดาวน์โหลด",
        "deptOrg": "โครงสร้างแผนก",
        "query": "ค้นหา",
        "queryByTerminalId": "ค้นหาตาม ID เทอร์มินัล",
        "batchDeleteLogs": "ลบบันทึกชุด",
        "customTimeDeleteLogs": "ลบบันทึกตามช่วงเวลาที่กำหนดเอง",
        "selectTimeRangeFirst": "โปรดเลือกช่วงเวลาก่อน",
        "deleteAllDeviceLogsIfEmpty": "หากไม่กรอก ID อุปกรณ์ จะลบบันทึกของอุปกรณ์ทั้งหมดโดยค่าเริ่มต้น",
        "enterDeviceIdToDeleteLogs": "โปรดป้อน ID อุปกรณ์ที่ต้องการลบบันทึก",
        "confirmDeleteAction": "ยืนยันการลบ",
        "selectDeleteRangeFirst": "โปรดเลือกช่วงที่จะลบก่อน",
        "networkConnectionFailed": "การเชื่อมต่อเครือข่ายล้มเหลว",
        "playLog": "บันทึกการเล่น",
        "publishLog": "บันทึกการเผยแพร่",
        "errorLog": "บันทึกข้อผิดพลาด",
        "operationLog": "บันทึกการดำเนินการ",
        "fileLog": "บันทึกไฟล์",
        "userOperateLog": "บันทึกการเข้าสู่ระบบ"
    },
    "userManual": {
        "userManual": "คู่มือผู้ใช้",
        "noData": "ไม่มีข้อมูล"
    },
    "systemNotice": {
        "systemNotice": "แจ้งเตือนระบบ",
        "noData": "ไม่มีข้อมูล",
        "total": "ทั้งหมด",
        "totalNum": "รายการ",
        "markAllRead": "ทำเครื่องหมายอ่านทั้งหมด",
        "deleteAll": "ลบทั้งหมด",
        "all": "ทั้งหมด",
        "unread": "ยังไม่อ่าน",
        "read": "อ่านแล้ว",
        "type": "ประเภท",
        "content": "เนื้อหา",
        "date": "วันที่",
        "status": "สถานะ",
        "confirmDelete": "ยืนยันการลบ?",
        "confirm": "ยืนยัน",
        "cancel": "ยกเลิก",
        "delete": "ลบ"
    }
};